import { useState } from 'react';
import styled from 'styled-components';
import { Box, Popover, PopoverProps, Typography } from '@mui/material';
import { ReactComponent as FilterIcon } from '../../assets/filter-2.svg';
import Button, { Props as ButtonProps } from '../Button';
import FilterSelector, {
  Props as FilterSelectorProps,
  OnSubmitEventVal,
} from '../FilterSelector';
import { fontWeight, radius, shadow, space } from '../../style/utils';

const PopoverStyled = styled(Popover)`
  .MuiPaper-root {
    min-width: 700px;
    padding: ${space('xxl')};
    box-shadow: ${shadow('md')};
    border-radius: ${radius('md')};
    border: 1px solid ${({ theme }) => theme.palette.border.subtle};
  }
`;

type Props = FilterSelectorProps & {
  buttonProps?: ButtonProps;
  popoverProps?: Partial<PopoverProps>;
};

const FilterPopover = ({ buttonProps, popoverProps, ...props }: Props) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleSubmit = (vals: OnSubmitEventVal) => {
    props.onSubmit?.(vals);
  };

  return (
    <Box>
      <Button
        variant="outlined"
        onClick={(e) => setAnchorEl(e.currentTarget)}
        startIcon={<FilterIcon />}
        disabled={props.disabled}
        {...buttonProps}
      >
        Filter
      </Button>
      <PopoverStyled
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 50,
          horizontal: 'left',
        }}
        {...popoverProps}
      >
        <Typography
          sx={{ fontWeight: fontWeight('semibold'), mb: 3 }}
          variant="body1"
        >
          Add filter
        </Typography>

        <FilterSelector
          {...props}
          onSubmit={handleSubmit}
          onClose={() => setAnchorEl(null)}
        />
      </PopoverStyled>
    </Box>
  );
};

export default FilterPopover;
